import { Grid, Stack, useTheme, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomeTextarea from "../../utils/CustomeTextarea";
import CustomTextField from "../../utils/CustomTextField";
import useWindowSize from "../../../hooks/useWindowSize";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RegisterYourPropertyFormSchema } from "./shema";
import axios from "axios";
import CustomSelect from "../../utils/CustomSelect";
import { toast } from "react-hot-toast";

const RegisterYourPropertyForm = () => {
  const theme = useTheme();
  const screenWidth = useWindowSize();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    clearErrors,
    register,
    watch,
    getValues,
  } = useForm({
    resolver: zodResolver(RegisterYourPropertyFormSchema),
  });

  const onSubmit = async ({ terms, ...data }) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_ESTAGE}/form/register-your-property`,
        data
      );

      reset({
        companyName: "",
      });

      toast.success("Registro enviado exitosamente", {
      style: {
        backgroundColor: "black",
        fontWeight: "700",
        fontFamily: "Arial",
        color: "#fff",
        fontSize: "16px",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
      duration: null, // Evita el cierre automático
      closeButton: true,
    });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Stack
        p={{ xs: 2, md: 4 }}
        border={`1px solid ${theme.palette.divider}`}
        borderRadius="10px"
        gap={3}
      >
        {" "}
        <Typography variant="h4" color="text.secondary" mb={2}>
          Información del proyecto
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Nombre de la empresa desarrolladora:"
              disabled={loading}
              id="first-name"
              placeholder="Ingrese su nombre de la empresa desarrolladora"
              onChange={(e) => {
                setValue("companyName", e.target.value);
                clearErrors("companyName");
              }}
              value={watch("companyName")}
              isError={errors.companyName}
              errorMsg={errors.companyName?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Nombre comercial:"
              id="last-name"
              disabled={loading}
              placeholder="Ingrese su nombre comercial"
              onChange={(e) => {
                setValue("tradeName", e.target.value);
                clearErrors("tradeName");
              }}
              value={getValues("tradeName")}
              isError={errors.tradeName}
              errorMsg={errors.tradeName?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="¿Qué puesto tienes en la empresa?"
              id="position"
              type="text"
              disabled={loading}
              placeholder="Ingrese su puesto"
              onChange={(e) => {
                setValue("positionCompany", e.target.value);
                clearErrors("positionCompany");
              }}
              value={getValues("positionCompany")}
              isError={errors.positionCompany}
              errorMsg={errors.positionCompany?.message}
            />
          </Grid>

          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="¿Cuál es la página web de tu proyecto/empresa?"
              id="website"
              disabled={loading}
              placeholder="Ingrese su página web"
              onChange={(e) => {
                setValue("webCompany", e.target.value);
                clearErrors("webCompany");
              }}
              value={getValues("webCompany")}
              isError={errors.webCompany}
              errorMsg={errors.webCompany?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomSelect
              placeholder="Seleccione"
              label="¿Has tokenizado algún proyecto antes?"
              data={[
                {
                  label: "Sí",
                  value: true,
                },
                {
                  label: "No",
                  value: false,
                },
              ]}
              onChange={(value) => {
                setValue("isTokenizeProject", value);
                clearErrors("isTokenizeProject");
              }}
              isSelect={!!getValues("isTokenizeProject")}
              isError={errors.isTokenizeProject}
              errorMsg={errors.isTokenizeProject?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomSelect
              placeholder="Seleccione"
              label="¿Qué tipo de recursos necesita tu proyecto? "
              data={[
                {
                  label: "Pre-Venta",
                  value: "pre-venta",
                },
                {
                  label: "Deuda",
                  value: "deuda",
                },
                {
                  label: "Inversión",
                  value: "inversion",
                },
              ]}
              onChange={(value) => {
                setValue("resourcesProject", value);
                clearErrors("resourcesProject");
              }}
              isSelect={!!getValues("resourcesProject")}
              isError={errors.resourcesProject}
              errorMsg={errors.resourcesProject?.message}
            />
          </Grid>
        </Grid>
        <Typography variant="h4" color="text.secondary" mb={2}>
          Información personal
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Nombre"
              disabled={loading}
              id="first-name"
              placeholder="Ingrese su nombre"
              onChange={(e) => {
                setValue("name", e.target.value);
                clearErrors("name");
              }}
              value={getValues("name")}
              isError={errors.name}
              errorMsg={errors.name?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Apellido"
              id="last-name"
              disabled={loading}
              placeholder="Ingrese su apellido"
              onChange={(e) => {
                setValue("lastName", e.target.value);
                clearErrors("lastName");
              }}
              value={getValues("lastName")}
              isError={errors.lastName}
              errorMsg={errors.lastName?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="¿Cuál es tu Correo electrónico?"
              id="email"
              type="mail"
              disabled={loading}
              placeholder="Ingrese su correo electrónico"
              onChange={(e) => {
                setValue("email", e.target.value);
                clearErrors("email");
              }}
              value={getValues("email")}
              isError={errors.email}
              errorMsg={errors.email?.message}
            />
          </Grid>

          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="¿Cuál es tu número de Whatsapp?"
              id="phone"
              disabled={loading}
              placeholder="Ingrese su número de Whatsapp"
              onChange={(e) => {
                setValue("phone", e.target.value);
                clearErrors("phone");
              }}
              value={getValues("phone")}
              isError={errors.phone}
              errorMsg={errors.phone?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomeTextarea
              id="message"
              disabled={loading}
              label="Información adicional"
              placeholder="Ingrese su mensaje aquí"
              maxRow={6}
              minRow={6}
              onChange={(e) => {
                setValue("message", e.target.value);
                clearErrors("message");
              }}
              value={getValues("message")}
              isError={errors.message}
              errorMsg={errors.message?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              alignItems={{ xs: "initial", md: "center" }}
              justifyContent="end"
              gap={1}
            >
              <Button
                type="submit"
                disabled={loading}
                variant="contained"
                sx={{
                  backgroundColor: "#a95052",
                  "&:hover": { backgroundColor: "#8c3e47" },
                }}
              >
                Enviar Registro
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </form>
  );
};

export default RegisterYourPropertyForm;
